// extracted by mini-css-extract-plugin
export default {"container":"CampaignGeneralSettings_container__jxAVv","title":"CampaignGeneralSettings_title__dEQjG"};